export default __webpack_public_path__ + "static/media/cardiovascular.1b0f880c.svg";